import { DefaultService } from '@/services/DefaultService';

export default class ClienteService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env);
    }

    save(file, cliente) {
        // Cria o formData para enviar o arquivo
        var data = new FormData();
        data.append('file', file);
        // Adiciona o objeto com os dados auxiliares do anexo.
        data.append(
            'cliente',
            new Blob([JSON.stringify(cliente)], {
                type: 'application/json',
            })
        );
        data.append('cliente', cliente);

        // Altera o Header para adicionar os headers necessários do multipart-data
        let requestHeader = {
            method: 'POST',
            headers: Object.assign(this._headers.headers),
            body: data,
        };

        // Remove o content-type do header para forçar o navegador a inseri-los novamente, gerando corretamente o content-type necessário.
        delete requestHeader.headers['Content-Type'];

        return this._http.post(`${this._env}/promotor/cliente`, data, requestHeader).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.handleError(err);
            }
        );
    }

    find(id) {
        return this._http.get(`${this._env}/promotor/cliente/${id}.json`, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.handleError(err);
            }
        );
    }

    delete(id) {
        return this._http.delete(`${this._env}/promotor/cliente/${id}`, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.handleError(err);
            }
        );
    }

    findAll(column, order, page, limit, situacao = 2, ...param) {
        return this._http
            .get(
                encodeURI(
                    `${
                        this._env
                    }/promotor/cliente.json?column=${column}&order=${order}&page=${page}&limit=${limit}&situacao=${situacao}&param=${param}`
                ),
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    getInfoByCNPJ(uf, cnpj) {
        return this._http
            .get(`${this._env}/general/cnpj.json?uf=${uf}&cnpj=${cnpj}`, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    getInfoByCEP(cep, token) {
        return this._http
            .post(
                `${this._env}/consultacep/${cep}`,
                { token: token },
                { 'Content-Type': 'application/json' }
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    containsAssClienteEmpresa() {
        return this._http
            .get(`${this._env}/cliente/contains-assclienteempresa`, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }
    updateLocation(form) {
        return this._http.post(`${this._env}/pro/cliente/location`, form, this._headers).then(
            (res) => {
                return res.body;
            },
            (err) => {
                this.handleError(err);
            }
        );
    }

    updateSituacao(cliente) {
        return this._http
            .post(`${this._env}/promotor/cliente/updatesituacao`, cliente, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.verifyError(err);
                    throw err;
                }
            );
    }

    getOrigensClienteCombo() {
        return this._http
            .get(`${this._env}/vendas/cliente/getcombo/origens.json`, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    getStatusClienteCombo() {
        return this._http
            .get(`${this._env}/vendas/cliente/getcombo/status.json`, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }

    findAllCombo(params) {
        return this.findAllComboSituacao(1, params);
    }
    findAllComboSituacao(situacao = 1, ...params) {
        return this._http
            .get(
                encodeURI(
                    `${
                        this._env
                    }/promotor/cliente/getcombo.json?situacao=${situacao}&param=${params}`
                ),
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.handleError(err);
                }
            );
    }
}
